export const types = {
    default: "Default Car",
    company: "Company Car",
    private: "Private Car",
    pool: "Pool Car",
}
